import styled from 'styled-components';
import { Columns } from '@components/Columns';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';

export const PlusOneAttendeeWrap = styled(Box)`
  padding-top: 0;
  ${themeMediaQuery('below_sm')} {
    padding-top: 0;
  }
  ${themeMediaQuery('sm')} {
    padding-top: 0;
  }
  ${themeMediaQuery('md')} {
    padding-top: 0;
  }
  ${themeMediaQuery('lg')} {
    padding-top: 0;
  }
`;

export const PlusOneAttendeeContent = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    padding-bottom: 80px;
  }
`;

export const PlusoneFeatureWrap = styled(Box)`
  max-height: 750px;
  ${themeMediaQuery('below_sm')} {
    min-height: calc(80vw + 300px);
    margin-bottom: -100px;
    max-height: unset;
  }
`;

export const PlusoneFeatureImageWrap = styled(Box)`
  position: relative;
  zindex: 4;
  ${themeMediaQuery('below_sm')} {
    top: 0px;
    padding-top: 30px;
  }
`;

export const PlusoneFeatureColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const PlusoneFeatureImage = styled(CloudImage)`
  position: absolute;
  z-index: 9;
  bottom: 80px;
  left: 0px;
  height: 290px;
  ${themeMediaQuery('below_sm')} {
    bottom: 70px;
    left: 0px;
    height: 160px;
  }
`;

export const OffsetTopColumn = styled(Columns.Column)`
  justify-content: center;
  align-items: flex-start;
  display: flex;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    order: 2;
  }
`;

export const PlusoneFeatureText = styled(TextPairing)`
  .text-pairing-title {
    max-width: 270px;
  }
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    align-items: center;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 360px;
    }
  }
`;

export const OffsetTopColumnImage = styled(Columns.Column)`
  justify-content: center;
  align-items: flex-start;
  display: flex;
  ${themeMediaQuery('below_sm')} {
    display: initial;
    order: 1;
  }
`;

export const AvatarBoxPositionWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 770px;
  margin: auto;
  max-width: 1440px;
  ${themeMediaQuery('below_sm')} {
    height: 580px;
  }
`;

export const PhoneWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 0;
`;

export const AvatarWrap = styled.div`
  transition: 0.5s;
  transform-style: preserve-3d;
  transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);
`;

export const AvatarContainer = styled.div<{
  bottom?: string;
  left?: string;
  top?: string;
  right?: string;
  height?: string;
  width?: string;
  resHeight?: string;
  isActive: boolean;

  resBottom?: string;
  resRight?: string;
  resLeft?: string;
}>`
  transform: ${(props) => (props.isActive ? 'rotate3d(45, 45, 0, 180deg)' : 'none')};
  position: absolute;
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  transition: 0.5s;
  transform-style: preserve-3d;
  transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);

  ${themeMediaQuery('below_sm')} {
    width: ${(props) => props.resHeight};
    height: ${(props) => props.resHeight};

    left: ${(props) => props.resLeft};
    right: ${(props) => props.resRight};
    bottom: ${(props) => props.resBottom};
  }
`;

export const BlackTransparancy = styled.div`
  background-color: rgba(17, 16, 16, 0.6);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 520px;
`;

export const AvtarFront = styled.div<{ height?: string; width?: string; resHeight?: string }>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  border-radius: 50%;
  background-color: ${themeColor('blue4')};
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  ${themeMediaQuery('below_sm')} {
    width: ${(props) => props.resHeight};
    height: ${(props) => props.resHeight};
  }
`;

export const AvtarFrontText = styled.p`
  font-family: cabin, sans-serif;
  font-weight: 600;
  font-size: 5rem;
  text-align: center;
  color: ${themeColor('mono7')};
  ${themeMediaQuery('below_sm')} {
    font-size: 2.5rem;
  }
`;

export const AvatarBack = styled.div`
  border-radius: 50%;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 2;
  transform: rotate3d(45, 45, 0, 180deg);
  background-color: #fff;
`;

export const AvatarBackImage = styled.div`
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
`;

export const OuterBorder = styled.div<{ height?: string; width?: string; borderResHeight?: string; isActive: boolean }>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  border-radius: 50%;
  // background-color: red;
  position: absolute;
  top: -16px;
  left: -16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 16px solid #fff5e5;
  transition: 0.5s;
  transform-style: preserve-3d;
  transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transform: ${(props) => (props.isActive ? 'rotate3d(45, 0, 0, 180deg)' : 'none')};

  ${themeMediaQuery('below_sm')} {
    width: ${(props) => props.borderResHeight};
    height: ${(props) => props.borderResHeight};
    border: 7px solid #fff5e5;
    top: -5px;
    left: -5px;
  }
`;

export const PlusOneNamesImage = styled(CloudImage)<{
  height?: string;
  width?: string;
  resHeight?: string;
  resWidth?: string;
}>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  ${themeMediaQuery('below_sm')} {
    width: ${(props) => props.resWidth};
    height: ${(props) => props.resHeight};
  }
`;
